// extracted by mini-css-extract-plugin
export default {"Orders":"AllOrders_Orders__FPK6J"};